var app = angular.module('leonardo');

var ClientInstanceService = function(BaseRestService, $q, RestangularProvider, ConfigThemeService, Upload, NotificationService) {
  var service = new BaseRestService('clientinstance');


  service.getBillingReports = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('whitelabels').customGET('report/billing', params).then(function(data){
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getClientInstanceById = function(id) {
    var defer = $q.defer();
    RestangularProvider.all('clientinstance').get('get-by-client-id/'+ id).then(function(data){
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.activate = function(account, sector, name) {
    var data = {
      sector: sector,
      name: name
    };
    return account.customPOST(data, 'activate');
  };

  service.reject = function(account) {
    return account.customPOST({}, 'reject');
  };

  service.onboardingFinished = function(account) {
    return account.customPOST({}, 'onboarding-finished');
  };

  service.post = function(params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/clientinstance/'),
      arrayKey: '',
      data: params
    }, function(error) {
      NotificationService.error(error);
    });
  };

  service.patch = function(id, params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/clientinstance/' + id + '/'),
      arrayKey: '',
      data: params,
      method: 'PUT'
    }, function(error) {
      NotificationService.error(error);
    });
  };

  return service;
};

app.factory('ClientInstanceService', ['BaseRestService', '$q', 'Restangular', 'ConfigThemeService', 'Upload',
  'NotificationService', ClientInstanceService]);
